import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { OrgCard, OrgCardArrow, OrgDescriptiveText, OrgInfo, OrgList, OrgLogo, OrgName, OrgSelectionContainer, } from "./OrgSelectionView.styles";
export { OrgSelectionEmailSubtitle, OrgSelectionNotYouLink } from "./OrgSelectionView.styles";
export const OrgSelectionView = observer((props) => {
    const { t } = useTranslation();
    return (_jsxs(OrgSelectionContainer, { children: [_jsx(OrgDescriptiveText, { children: t("This email is linked to multiple organizations. Choose one to continue.") }), _jsx(OrgList, { children: props.organizations.map((org) => (_jsxs(OrgCard, { onClick: () => props.onSelect(org.id), children: [_jsxs(OrgInfo, { children: [org.logoUrl && _jsx(OrgLogo, { src: org.logoUrl, alt: org.name }), _jsx(OrgName, { children: org.name })] }), _jsx(OrgCardArrow, {})] }, org.id))) })] }));
});
addDisplayName(OrgSelectionView, "OrgSelectionView");
